'use es6';

import { useState } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UIIcon from 'UIComponents/icon/UIIcon';
import UISelect from 'UIComponents/input/UISelect';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.${key}`;
const PropertySelect = ({
  useOnDark,
  onChange,
  options
}) => /*#__PURE__*/_jsx(UISelect, {
  "data-selenium": "form-field-add-property-select",
  className: "m-bottom-1",
  onChange: ({
    target: {
      value
    }
  }) => onChange(value),
  options: options,
  placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
    message: i18nKey('propertySelect.label')
  }),
  buttonUse: useOnDark ? 'form-on-dark' : 'form'
});
const CancelButton = ({
  onClick
}) => /*#__PURE__*/_jsx(UIButton, {
  "data-selenium": "form-field-add-cancel-button",
  className: "m-left-0",
  use: "tertiary",
  size: "extra-small",
  onClick: onClick,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: i18nKey('addFormField.cancel')
  })
});
const AddFieldButton = ({
  onClick,
  readOnly
}) => /*#__PURE__*/_jsxs(UILink, {
  "data-selenium": "form-field-add-button",
  disabled: readOnly,
  onClick: onClick,
  children: [/*#__PURE__*/_jsx(UIIcon, {
    name: "add"
  }), /*#__PURE__*/_jsx(FormattedMessage, {
    message: i18nKey('addFormField.label')
  })]
});
const AddField = ({
  onSelectProperty = () => {},
  propertyOptions = [],
  useOnDark = false,
  readOnly = false
}) => {
  const [isAdding, setIsAdding] = useState(false);
  const onSelect = property => {
    setIsAdding(false);
    onSelectProperty(property);
  };
  return isAdding ? /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(PropertySelect, {
      useOnDark: useOnDark,
      onChange: onSelect,
      options: propertyOptions
    }), /*#__PURE__*/_jsx(CancelButton, {
      onClick: () => setIsAdding(false)
    })]
  }) : /*#__PURE__*/_jsx(AddFieldButton, {
    onClick: () => setIsAdding(true),
    readOnly: readOnly
  });
};
AddField.propTypes = {
  propertyOptions: PropTypes.array,
  useOnDark: PropTypes.bool,
  onSelectProperty: PropTypes.func,
  readOnly: PropTypes.bool
};
export default AddField;